import React from 'react';
import { Link } from 'react-router-dom';
import Header from './shared/Header';
import Navigation from './shared/Navigation';
import { getRandomColor } from '../utils/colors';
const BooksPage = () => {
  return <div className="min-h-screen bg-[#faf9f7] text-[#333333] font-serif" data-id="element-100" data-mp="1yplxh2n23oa9">
      <Header data-id="element-101" data-mp="23oozee7qpee0" />
      <main className="flex min-h-screen pt-24 px-6" data-id="element-102" data-mp="23p87z4bi2qfd">
        <div className="flex flex-col md:flex-row w-full max-w-6xl mx-auto" data-id="element-103" data-mp="23r2rce74iahc">
          <div className="w-full md:w-1/4 mb-8 md:mb-0" data-id="element-104" data-mp="170actkzu8qho">
            <Navigation data-id="element-105" data-mp="1azrjuiuwxvoy" />
          </div>
          <div className="w-full md:w-3/4 md:pl-8" data-id="element-106" data-mp="1b0t49dxtjujc">
            <div className="max-w-2xl" data-id="element-107" data-mp="1fyupo5ipw5xz">
              <div className="mb-8" data-id="element-108" data-mp="1fxt251kilqzd">
                <div className="text-base mb-4" data-id="element-109" data-mp="1kyh1qbmt7g57">Author</div>
                <ul className="list-none space-y-2" data-id="element-110" data-mp="1l01xu5orv756">
                  <li data-id="element-111" data-mp="2ret12g1db42d">
                    <Link to="/body-not-thing" className="transition-colors duration-200" onMouseEnter={e => {
                    e.currentTarget.style.color = getRandomColor();
                  }} onMouseLeave={e => {
                    e.currentTarget.style.color = '#333333';
                  }} data-id="element-112" data-mp="2rdhphu1oks0p">
                      The Body Is Not A Thing (Coming soon...)
                    </Link>
                  </li>
                  <li data-id="element-113" data-mp="22xcas3vyxqih">
                    <Link to="/quarry" className="transition-colors duration-200" onMouseEnter={e => {
                    e.currentTarget.style.color = getRandomColor();
                  }} onMouseLeave={e => {
                    e.currentTarget.style.color = '#333333';
                  }} data-id="element-114" data-mp="1xvwq4cxpdm0m">
                      The Quarry (Self-published, 2022)
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="mb-8" data-id="element-115" data-mp="1a8nj0vgsyxje">
                <div className="text-base mb-4" data-id="element-116" data-mp="10j89qbhrl01w">Editor</div>
                <ul className="list-none space-y-2" data-id="element-117" data-mp="10l1flokjzg8u">
                  <li data-id="element-118" data-mp="15ibcfpa9uu6p">
                    <a href="https://www.phaidon.com/monacelli/art-and-photography/emerald-drifters-9781580936873/" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                    e.currentTarget.style.color = getRandomColor();
                  }} onMouseLeave={e => {
                    e.currentTarget.style.color = '#333333';
                  }} data-id="element-119" data-mp="15jmgzrbjk5yv">
                      Emerald Drifters, Cig Harvey (Monacelli)
                    </a>
                  </li>
                  <li data-id="element-120" data-mp="227iqkc8ka10l">
                    <a href="https://www.libraryman.se/odette-england-the-long-shadow/" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                    e.currentTarget.style.color = getRandomColor();
                  }} onMouseLeave={e => {
                    e.currentTarget.style.color = '#333333';
                  }} data-id="element-121" data-mp="2267l87zgwl7d">
                      The Long Shadow, Odette England (Libraryman)
                    </a>{' '}
                    <em data-id="element-122" data-mp="33sa99plnzgrh">*text edit only</em>
                  </li>
                  <li data-id="element-123" data-mp="3iorgc4mtm988">
                    <a href="https://www.youtube.com/watch?v=Jqhk4oU-suA" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                    e.currentTarget.style.color = getRandomColor();
                  }} onMouseLeave={e => {
                    e.currentTarget.style.color = '#333333';
                  }} data-id="element-124" data-mp="3ipar91e1zxcr">
                      Bluest Bruise, Joan Haseltine (For the Birds Trapped in
                      Airports)
                    </a>
                  </li>
                  <li data-id="element-125" data-mp="3co0oz8mqcpvs">
                    <a href="https://www.schiltpublishing.com/shop/books/new-releases/you-refuse-to-believe-that-you-ever-liked-pink/" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                    e.currentTarget.style.color = getRandomColor();
                  }} onMouseLeave={e => {
                    e.currentTarget.style.color = '#333333';
                  }} data-id="element-126" data-mp="3coac8oge4ixs">
                      You Refuse To Believe You Ever Liked Pink, Dena Eber
                      (Schildt Publishing)
                    </a>
                  </li>
                </ul>
              </div>
              <div className="mb-8" data-id="element-127" data-mp="ea1efgvim3x5">
                <div className="text-base mb-4" data-id="element-128" data-mp="9cjeuh3e111t">What does an editor do?</div>
                <ul className="list-none space-y-2" data-id="element-129" data-mp="9em1qs98ue2b">
                  <li className="flex" data-id="element-130" data-mp="5bprbotuxo9g">
                    <span className="mr-2" data-id="element-131" data-mp="5cr0tov862p2">•</span>
                    <div data-id="element-132" data-mp="121qe5iao1uo4">
                      Refines concept and narrative to support the book's core
                      themes and intent.
                    </div>
                  </li>
                  <li className="flex" data-id="element-133" data-mp="savmtzikc4vt">
                    <span className="mr-2" data-id="element-134" data-mp="s9udbzh73qg7">•</span>
                    <div data-id="element-135" data-mp="oa23ljg2fe99">
                      Develops image sequence and selection to build visual and
                      emotional rhythm.
                    </div>
                  </li>
                  <li className="flex" data-id="element-136" data-mp="1g185o5fcjm16">
                    <span className="mr-2" data-id="element-137" data-mp="1g06i51h5972k">•</span>
                    <div data-id="element-138" data-mp="3a8trp2x4xkib">
                      Edits all written material — captions, statements, essays
                      — for clarity, tone, and alignment.
                    </div>
                  </li>
                  <li className="flex" data-id="element-139" data-mp="30jk1jsluqbwu">
                    <span className="mr-2" data-id="element-140" data-mp="30ihb1lsfybhg">•</span>
                    <div data-id="element-141" data-mp="35htz29v1tolm">
                      Ensures consistency across text, design, and structure in
                      service of the story.
                    </div>
                  </li>
                  <li className="flex" data-id="element-142" data-mp="2wh5jvbtx5i75">
                    <span className="mr-2" data-id="element-143" data-mp="2wi6tdbvadwmr">•</span>
                    <div data-id="element-144" data-mp="2hk65n54kar3p">
                      Collaborates closely with photographer, designer, and
                      publisher to uphold the vision.
                    </div>
                  </li>
                </ul>
              </div>
              <div data-id="element-145" data-mp="fu315bwx63hg">
                <p data-id="element-146" data-mp="ftkv5nkggawc">
                  If you are interested in working together on a photo book
                  please email me directly to enquire.
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>;
};
export default BooksPage;